import Footer24 from '@/components/organisms/Footer24';
import Header24 from '@/components/organisms/Header24';
import SeguroAuto25 from '@/components/templates/SeguroAuto25';
import SeguroAuto25Banner from '@/components/organisms/SeguroAuto25Banner';
import CDCProtegido25 from '@/components/templates/CDCProtegido25';
import MaoNaRoda25 from '@/components/templates/MaoNaRoda25';
import { SeguroTabs } from '@/data/misc/seguros-tabs';
import React, { useState } from 'react';
import CustomTabs from '../CustomTabs';
import SegurosConteudos from '@/components/organisms/SegurosConteudos';
import CDCProtegido25Banner from '@/components/organisms/CDCProtegido25Banner';
import MaoNaRoda25Banner from '@/components/organisms/MaoNaRoda25Banner';
import Styles from './TabGroupSeguros.css';

function TabGroupSeguros({ tab }) {
  const [currentTab, setCurrentTab] = useState(tab);

  const handleTab = (id) => {
    setCurrentTab(id);
  };

  return (
    <>
      <Header24 />

      {currentTab === SeguroTabs['seguro-santander-auto'].id && <SeguroAuto25Banner />}
      {currentTab === SeguroTabs['cdc-protegido'].id && <CDCProtegido25Banner />}
      {currentTab === SeguroTabs['mao-na-roda'].id && <MaoNaRoda25Banner />}

      <CustomTabs
        initialTab={tab}
        tabs={SeguroTabs}
        onTabChanged={handleTab}
        className={currentTab === SeguroTabs['seguro-santander-auto'].id && 'tab-seguro-auto'}
      />

      {currentTab === SeguroTabs['seguro-santander-auto'].id && <SeguroAuto25 />}
      {currentTab === SeguroTabs['cdc-protegido'].id && <CDCProtegido25 />}
      {currentTab === SeguroTabs['mao-na-roda'].id && <MaoNaRoda25 />}

      <Footer24 />
      <style jsx>{Styles}</style>
    </>
  );
}

export default TabGroupSeguros;
